import { groq } from 'next-sanity'
import { flexibleContent, seoFields } from '../partials/shared'

export const marketsBySlugQuery = groq`*[_type == "marketPages" && slug.current == $slug][0] {
	_id,
	slug,
	title,
  headline,
	subHeadline,
	introduction,
	secondIntro,
	${flexibleContent}
  ${seoFields}
}`

export const marketsBySlugSeoQuery = groq`*[_type == "marketPages" && slug.current == $slug][0]{
	${seoFields}
}`
